import { Injectable } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { Plugins } from '@capacitor/core';
import { filter } from 'rxjs/operators';
import "@capacitor-community/firebase-analytics"

const { FirebaseAnalytics } = Plugins

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {


  constructor(
    private router: Router
  ) {
    FirebaseAnalytics.setCollectionEnabled({ enabled: true });
    this.router.events.pipe(
      filter((e: RouterEvent) => e instanceof NavigationEnd),
    ).subscribe((e: RouterEvent) => {
      this.setScreenName(`${e.url}`)
    })
  }


  public async setUserId(userId: string) {
    FirebaseAnalytics.setUserId({
      userId: userId.toString(),
    });
  }

  /*
  Params
    acesso_de: 'tabs', 'home', 'menu'
    tipo_ativo: 'B', 'C', 'INDICE'...
    prazo: 'longo', 'medio', 'curto'
  */
  public logEvent(eventName: string, params: object = {}) {
    eventName = eventName.toLowerCase().replace(/ /g, '_').replace(/-/g, '_')
    FirebaseAnalytics.logEvent({
      name: eventName,
      params
    })
  }

  public setUserProperty(name: string, value) {
    FirebaseAnalytics.setUserProperty({
      name: name,
      value: value
    });
  }

  private setScreenName(screenName: string) {
    FirebaseAnalytics.setScreenName({
      screenName: screenName,
    })
  }
}
